<div
  id="progress"
  [ngStyle]="{
    background:
      'conic-gradient(' +
      completedColor +
      ' ' +
      currentProgress +
      '%, ' +
      remainingColor +
      ' ' +
      currentProgress +
      '%)',
  }"
>
  <span
    id="progress-value"
    [ngStyle]="{
      width: 'calc(100% - ' + progressWidth * 2 + 'px)',
      height: 'calc(100% - ' + progressWidth * 2 + 'px)',
    }"
  ></span>
  <ion-icon id="image" #image *ngIf="imageSrc" [src]="imageSrc" [ngClass]="{ animatedImage: animatedImage }"></ion-icon>
  <div
    id="roundShape"
    #roundShape
    [ngStyle]="{ transform: 'rotate(' + (currentProgress * 360) / 100 + 'deg)' }"
    [ngClass]="{ started: currentProgress > 0 }"
  ></div>
</div>
